import { HeatingModeEnum } from "../../components/recipeCreation/utils/constants"

export const initialRecipeData = {
    "id": "",
    "diet": [],
    "name": "",
    "active": true,
    "author": "",
    "editor": "",
    "cuisine": [],
    "created_at": "",
    "created_by": "",
    "description": null,
    "created_source": "",
    "last_edited_at": "",
    "Recipe_Variations": [
        {
            "id": "",
            "name": "",
            "tags": [],
            "active": true,
            "default": true,
            "metadata": {},
            "image_url": "",
            "prep_time": 0,
            "recipe_id": "",
            "created_at": "",
            "parameters": {},
            "updated_at": "",
            "description": "",
            "ingredients": [],
            "max_serving": 2,
            "min_serving": 2,
            "cooking_time": 0,
            "RecipeVariations_Steps": [
                {
                    "StepsE3": {
                        "id": "",
                        "created_at": "",
                        "updated_at": "",
                        "Steps_Substeps": []
                    },
                    "step_id": "",
                    "step_rank": 0,
                    "recipeVariation_id": ""
                }
            ]
        }
    ],
    "recipe_market_price": 0
}

export const initialSubstep = {
    "step_id": "",
    "subStep_id": "",
    "subStepUId": "",
    "subStep_rank": 0,
    "SubstepsE3": {
        "id": "",
        "subStepUId": "",
        "media": {
            "loop": true,
            "muted": true,
            "title": "",
            "duration": 0,
            "imageURL": "",
            "videoURL": "",
            "startTime": 0
        },
        "parameters": {
            "location": "bowl",
            "outsideDescription": ""
        },
        "type": "outsideInstruction",
        "created_at": "",
        "updated_at": "",
        "name": ""
    },
    "initial": true,
}

export const initialSetting = {
    "time": 0,
    "speed": 0,
    "exitTime": 4200,
    "stirDuty": 6,
    "stirAngle": 140,
    "scaleModel": {
        "type": "none"
    },
    "heatingMode": HeatingModeEnum.TAT,
    "temperature": 20,
    "strategyType": "manual"
}